export default __webpack_public_path__ + "static/media/goshen29.220c5ea6.jpg";